import { Component, ViewChild } from "@angular/core";
import { Company } from "./models/company";
import { defaultHiringTypes } from "./models/hiringType"
import { defaultBenefits, BenefitEnum } from "./models/benefit"
import { TaxService } from "./services/tax.service"
import { MatTable } from '@angular/material/table'
import { MatDialog } from '@angular/material/dialog'
//import {} from '@angular/material/expansion'
import { DaysComponent } from './dialogs/days/days.component';
import { DisclaimerComponent } from './dialogs/disclaimer/disclaimer.component';
import { id } from "@swimlane/ngx-charts";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  // chart
  single: any[] = [];

  view: any[] = [700, 400];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  rotateXAxisTicks = 'true';
  xAxisLabel = 'Posición';
  showYAxisLabel = true;
  yAxisLabel = '$ Anualizado Neto';

  colorScheme = {
    domain: [
    '#a8385d',
    '#7aa3e5',
    '#a27ea8',
    '#aae3f5',
    '#adcded',
    '#a95963',
    '#8796c0',
    '#7ed3ed',
    '#50abcc',
    '#ad6886']
  };
  
  MAX_NET_SALARY = -999999;
  //
  panelOpenState = false;
  title = "job2job";
  companies: Company[] = [];
  defaultHiringTypes = [];
  defaulBenefits = [];
  minAmountCompanies = 2;
  amountCompanies = 2;
  lastAmountCompanies = 0;
  


  @ViewChild(MatTable,{static:true}) table: MatTable<any>;
  constructor(public dialog: MatDialog) {
    this.updateCompaniesAmount();
    this.defaultHiringTypes = defaultHiringTypes;
    this.defaulBenefits = defaultBenefits;
    this.openDisclaimer();
  }

  updateCompaniesAmount() {
    if (this.companies.length === 0) {
      for (let i = 0; i < this.amountCompanies; i++) {
        this.createPushCompany(i+1);
      }
    }
  }

  createPushCompany(id) {
    const x = new Company(id);
    this.companies.push(x);
    this.single.push({
      id: x.id,
      name: x.nameChart,
      value: 0
    });
    this.single = [...this.single];
  }
  addCompany() {
    this.amountCompanies++;
    this.createPushCompany(this.amountCompanies);
    this.table.renderRows();
  }
  
  removeCompany() {
    if (this.amountCompanies - 1 >= this.minAmountCompanies) {
      this.companies.pop();
      this.amountCompanies--;
      this.table.renderRows();
      this.single.pop();
      this.single = [...this.single];
    }
  }

  updateSalaryAnualized(element, salary?){
    if (!salary) {
      salary = element.salary
    }

    element.salaryAnualized = salary * 12;
    
    if (element.hiringTypeId === 1) {
      element.taxes["0"] = new TaxService().calculateTax(element.salaryAnualized);
      
      if ((element.benefits[BenefitEnum.CHRISTMASBONUS.toString()])) {
        element.salaryAnualized = element.salaryAnualized + ((element.salary/30) * element.benefits[BenefitEnum.CHRISTMASBONUS.toString()].value);
        element.taxes[BenefitEnum.CHRISTMASBONUS.toString()] = new TaxService().calculateChristmasBonusTax(element.salary, element.benefits[BenefitEnum.CHRISTMASBONUS.toString()].value);
      }
      
      if ((element.benefits[BenefitEnum.VACATIONBONUS.toString()])) {
        element.salaryAnualized = element.salaryAnualized + ((element.salary/30) * (element.vacationDays) * (element.benefits[BenefitEnum.VACATIONBONUS.toString()].value/100));
        element.taxes[BenefitEnum.VACATIONBONUS.toString()] = new TaxService().calculateVacationBonusTax(element.salary, element.vacationDays, element.benefits[BenefitEnum.VACATIONBONUS.toString()].value);
      }
      
      if ((element.benefits[BenefitEnum.SAVINGFUND.toString()])) {
        element.salaryAnualized = element.salaryAnualized + (element.benefits[BenefitEnum.SAVINGFUND.toString()].value*12);
      }
      
      if ((element.benefits[BenefitEnum.PERFORMANCEBONUS.toString()])) {
        element.salaryAnualized = element.salaryAnualized + (element.benefits[BenefitEnum.PERFORMANCEBONUS.toString()].value);
        element.taxes[BenefitEnum.PERFORMANCEBONUS.toString()] = new TaxService().calculatePerformanceBonusTax(element.salary, element.benefits[BenefitEnum.PERFORMANCEBONUS.toString()].value);
      }
      
    } else {
      element.taxes["0"] = null;
      if ((element.benefits[BenefitEnum.PERFORMANCEBONUS.toString()])) {
        element.salaryAnualized = element.salaryAnualized + (element.benefits[BenefitEnum.PERFORMANCEBONUS.toString()].value);
      }
    }
    if ((element.benefits[BenefitEnum.FOODVOUCHER.toString()])) {
      element.salaryAnualized = element.salaryAnualized + (element.benefits[BenefitEnum.FOODVOUCHER.toString()].value * 12)
    }
    if ((element.benefits[BenefitEnum.HOMEOFFICEALLOWANCE.toString()])) {
      element.salaryAnualized = element.salaryAnualized + (element.benefits[BenefitEnum.HOMEOFFICEALLOWANCE.toString()].value * 12)
    }
    if ((element.benefits[BenefitEnum.TRAININGBUDGET.toString()])) {
      element.salaryAnualized = element.salaryAnualized + (element.benefits[BenefitEnum.TRAININGBUDGET.toString()].value)
    }
    if ((element.benefits[BenefitEnum.HOMEOFFICESETUP.toString()])) {
      element.salaryAnualized = element.salaryAnualized + (element.benefits[BenefitEnum.HOMEOFFICESETUP.toString()].value)
    }

    element.totalTaxes = this.getTaxes(element);
    element.netSalary = this.getNetAnualized(element);
    this.updateValueChart(element.id, element.netSalary);
    this.getParecentageDiff();
  }

  getTaxes(element) {
    let totalTaxes = 0;
    Object.values(element.taxes).forEach(tax => {totalTaxes = totalTaxes + Number(tax) });
    return totalTaxes;
  }
  
  getNetAnualized(element) {
    let netAnualized = element.salaryAnualized;
    Object.values(element.taxes).forEach(tax => {netAnualized = netAnualized - Number(tax) });
    return netAnualized;
  }

 
  openDialog(benefit) {
    let dialogRef = null;
    switch (benefit.type) {
      case 1:
        dialogRef = this.dialog.open(DaysComponent, {
          data: { companies: this.companies, benefit}
        });
        dialogRef.afterClosed().subscribe(_ => {
          console.log(this.companies);
          this.companies.forEach(company => {
            this.updateSalaryAnualized(company);
          });
        });
        break;
      case 2:
        dialogRef = this.dialog.open(DaysComponent, {
          data: { companies: this.companies, benefit}
        });
        dialogRef.afterClosed().subscribe(_ => {
          this.companies.forEach(company => {
            this.updateSalaryAnualized(company);
          });
        });
        break;
      case 3:
        dialogRef = this.dialog.open(DaysComponent, {
          data: { companies: this.companies, benefit}
        });
        dialogRef.afterClosed().subscribe(_ => {
          this.companies.forEach(company => {
            this.updateSalaryAnualized(company);
          });
        });
        break;
      case 4:
        dialogRef = this.dialog.open(DaysComponent, {
          data: { companies: this.companies, benefit}
        });
        dialogRef.afterClosed().subscribe(_ => {
          this.companies.forEach(company => {
            this.updateSalaryAnualized(company);
          });
        });
        break;
      
      case 5:
        dialogRef = this.dialog.open(DaysComponent, {
          data: { companies: this.companies, benefit}
        });
        dialogRef.afterClosed().subscribe(_ => {
          this.companies.forEach(company => {
            this.updateSalaryAnualized(company);
          });
        });
        break;
    
      default:
        break;
    }
  }

  openDisclaimer(){
      const dialogRef = this.dialog.open(DisclaimerComponent);
  
      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
  }

  updateValueChart(id, value){
    const company = this.single.find(item => item.id === id);
    company.value = value;
    this.single = [...this.single];
  }

  getParecentageDiff() {
    this.MAX_NET_SALARY = -999999;
    this.companies.forEach(company => {
      this.MAX_NET_SALARY = Math.max(this.MAX_NET_SALARY, company.netSalary);
    });
    this.companies.forEach(company => {
      if (company.netSalary === this.MAX_NET_SALARY) {
        company.nameChart = company.name;
      } else {
        company.nameChart = `${company.name} (-${Math.trunc(((this.MAX_NET_SALARY - company.netSalary)/company.netSalary) * 100)}%)`;
      }
      const companyChart = this.single.find(item => item.id === company.id);
      companyChart.name = company.nameChart;
      this.single = [...this.single];
    });
  }
  
  displayedColumns: string[] = ['name', 'salary', 'hiringTypeId', 'vacationDays'];
  displayedResultColumns: string[] = ['name', 'salaryAnualized', 'salaryAnualizedTax', 'salaryAnualizedNet'];
}


